import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Inspeccion30Y31Ano2024DatosGenerales() {
  return <CategoryPage category="inspeccion30Y31Ano2024DatosGenerales" pageTitle="Datos Generales" />;
}

export default Inspeccion30Y31Ano2024DatosGenerales;
